export default {
  title: 'Group Scoring',
  paper: 'Questions',
  scoreStatus: 'Class standard',
  table: {
    name: 'name',
    number: 'number',
    score: 'score',
    average: 'average',
    class: 'class',
    comment: 'Comment',
    examScore: 'Exam score',
    viewPaper: 'View Questions',
    noData: 'No information yet',
    min: 'Minimum value',
    max: 'Maximum value',
    point: '{number} point',
    halfPoint: 'half',
    fullPoint: 'full score',
    setScore: 'Score',
    edit: 'Edit',
  },
  dialogTitle: "Interviewer's comment",
  remarkPlaceholder: 'Please enter something',
  cancel: 'Cancel',
  confirm: 'Confirm',
  imagePreview: 'Image preview',
  checkInTips: 'The candidate has not been signed in yet, please sign in the candidate first.',
  goCheckIn: 'Go check in the candidates',
  checkInComment: 'Only review signed candidates',
  // checkStatusWaiting: "The interview for this candidate has not yet begun",
  checkStatusWaiting: 'You haven’t started scoring yet. Would you like to start now?',
  checkStatusComplete:
    'The interview is over, please return to the list page to modify the score by clicking on a single candidate',
  error307: 'You have been scored by the administrator, click OK, you will be redirected to the home page',
  noPaperAlert: {
    title: 'Tip',
    msg: 'There are no valid questions at this time!',
    expired:
      'The original content is invalid, this time will open a new content, the new content is valid for a period of time',
  },
  noPaper: 'No Questions',
  operateContent: {
    waiting: 'Start Scoring',
    interviewing: 'Submit',
  },
  stateContent: {
    interviewing: 'Be Scoring',
    complete: 'To adjust the score, please return to the list page and click a single one.',
  },
  exceedMaximumScore: 'Rating score does not match the preset score',
  viewQuestions: 'View Questions',
  closeQuestions: 'Close Questions',
  notDrawnPaper: 'Not yet drawn',
  scoreSheet: 'Score Sheet',
  questionsTab: 'Questions',
  noQuestions: 'No Questions',
  singleRating: 'Single Rating',
  groupRating: 'Group Rating',
  selectRatingMode: 'Select Rating Mode',
  candidateInfoTitle: 'Candidate Information',
  viewAttachment: 'View Attachment',
  genderMale: 'Male',
  genderFemale: 'Female',
};
